var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ktab_tag"},[_c('ul',_vm._l((_vm.ktabname),function(item,index){return _c('li',{key:index,class:{'nav_select_selected':item.class_true},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(item.key,index)}}},[_vm._v(_vm._s(item.value))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }